import { toast } from 'react-toastify';

export default function ToastMessage(type, message, time = 2000, options = {}) {
  const TOASTCONFIG = {
    position: 'top-center',
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    pauseOnFocusLoss: false,
    draggable: true,
    className: 'toast-config',
    ...options,
  };

  switch (type) {
    case 'success':
      return toast.success(message, TOASTCONFIG);
    case 'error':
      return toast.error(message, TOASTCONFIG);
    case 'warn':
      return toast.warn(message, TOASTCONFIG);
    case 'info':
      return toast.info(message, TOASTCONFIG);
    case false:
      return toast.dismiss();
    default:
      return toast.success(message, TOASTCONFIG);
  }
}
